import React from 'react';
import { isSpectator, isLiveInProgress, isLiveEnded, getNickname } from '../../../helpers';
import { addBatchCustomData, removeBatchCustomData } from '../../../services/notifications';
import { List, Switch } from 'antd-mobile';
import _ from 'lodash';

const SwitchNotifButton = ({live, receiveNotif, setReceiveNotif, id}) => (
    <div style={{position: 'absolute', top: 'auto', bottom: '0', width: '100%'}}>
    {
        isSpectator([live]) && !isLiveInProgress(live) && !isLiveEnded(live) &&
        <List>
            <List.Item
                wrap
                extra={
                    <Switch
                        onChange={(b) => {
                            const change = b ? 1 : 0;
                            localStorage.setItem(`/notif/lives/${id}`, change);
                            setReceiveNotif(change);

                            if(change === 1) {
                                addBatchCustomData({"ut.recipient": { "$add": [`live_${id}`]}});
                            }
                            else {
                                removeBatchCustomData([`live_${id}`]);
                            }
                        }}
                        checked={parseInt(receiveNotif) === 1} 
                        color='#004586' 
                    />
                }
            >
                <div className='common'>
                    M'avertir lors du début du live {live && !_.isEmpty(live) && live.author ? `de ${getNickname(live.author.firstname, live.author.lastname, live.author.nickname)}` : ''} pour la rencontre
                </div>
            </List.Item>
        </List>
    }
    </div>
);

export default SwitchNotifButton;